"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable max-len */
var _default = exports["default"] = 'M8.025 5.427C9.005 6.52 9.833 7.71 9.833 7.71s.682.937.08 1.544c-.398.4-.94 1.352-.66 1.757.28.407 3.736 3.738 3.736 3.738s.395.345.66.22c.263-.127 1.537-.88 1.537-.88s.526-.178 1.1.22c.576.4 2.356 1.582 2.356 1.582s.507.638.152 1.2c-.356.564-1.466 1.678-1.466 1.678s-.442.3-1.442.062c-1-.237-3.335-.795-6.537-3.995-2.96-2.96-4.262-6.943-4.262-6.943s-.095-.694.327-1.31c.422-.62 1.67-2.2 2.61-1.155z';